<template>
  <div class="flex h-[85vh] flex-col items-center justify-center space-y-6">
    <img class="w-32 h-32" alt="404 picture" src="/images/mascot.svg" />
    <div
      class="py-4 flex items-center justify-center divide-x-2 divide-gray-200"
    >
      <div class="px-4 text-5xl font-bold">404</div>
      <div class="px-4 text-2xl">Страница не найдена</div>
    </div>
    <p class="max-w-[480px] text-center text-mine-shaft-400">
      Такое случается, когда делаются переезды на новую систему. Вполне
      возможно, что изменился адрес конечной ссылки или мы ещё не успели создать
      эту страницу.
    </p>
    <router-link
      class="mt-4 text-primary"
      to="/"
      v-text="'Вернуться на главную страницу'"
    />
  </div>
</template>

<script setup>
import { useSeoMeta } from 'unhead'

useSeoMeta({
  title: '404',
  description:
    'Мы не смогли найти эту страницу, такое случается, когда делаются переезды на новую систему. Вполне возможно, что изменился адрес конечной ссылки или мы ещё не успели создать эту страницу.',
})
</script>
